import React from 'react';
import PropTypes from 'prop-types';
import NonEmptyArrayField from './NonEmptyArrayField';
import TextField from './TextField';
import Button from '../Button';

export default function EmailArray({
  value, errors, onChange, widthSmall, widthBig, label, customClassName
}) {
  return (
    <NonEmptyArrayField
      value={value}
      defaultValue=''
      errors={errors}
      onChange={onChange}
      renderer={({
        val, getHandler: getH, del, add, idx, length, errors: errs,
      }) => {
        return (
          <div key={idx} className={customClassName}>
            <TextField
              style={{ width: ((idx === length - 1) && (length > 1)) ? widthSmall : widthBig }}
              label={label}
              placeholder='Email Address'
              value={val.value || ''}
              onChange={getH('value')}
              error={errs.value}
            />
            {length > 1 && (
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  del();
                }}
                style={{
                  padding: '0px 5px',
                  marginLeft: 5,
                  verticalAlign: 'top',
                  height: 28,
                  marginTop: 15,
                }}
              >
                <i className="material-icons">delete</i>
              </Button>
            )}
            {(idx === length - 1) && (
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  add();
                }}
                style={{
                  padding: '0px 5px',
                  marginLeft: 5,
                  verticalAlign: 'top',
                  height: 28,
                  marginTop: 15,
                }}
              >
                <i className="material-icons">add</i>
              </Button>

            )}
          </div>
        );
      }}
    />
  );
}

EmailArray.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.shape(),
    PropTypes.string,
  ])),
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
  widthSmall: PropTypes.number,
  widthBig: PropTypes.number,
};

EmailArray.defaultProps = {
  value: [],
  errors: {},
  widthSmall: 150,
  widthBig: 171,
};
